import React, { PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'

import Navbar from 'components/Navbar'
import bannerContext from 'containers/Banner/bannerContext'

const StyledHeader = styled.header<{ hideShadow?: boolean }>`
  width: 100%;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex[4]};

  /* Have the fixed as safeguard for older browsers */
  position: fixed;
  position: sticky;

  ${({ hideShadow }) =>
    hideShadow &&
    `
    ${Navbar} {
      box-shadow: none;
    }
  `}
`

interface HeaderProps {
  className?: string
}

const Header = React.forwardRef<HTMLElement, PropsWithChildren<HeaderProps>>(
  function Header({ children, className }, ref) {
    const { items } = useContext(bannerContext)

    return (
      <StyledHeader
        className={className}
        ref={ref}
        hideShadow={items.length > 0}
      >
        {children}
      </StyledHeader>
    )
  }
)

export default Header
